import { Link } from "react-router";
import {
  Container,
  Section,
  Heading,
  Lede,
  Eyebrow,
} from "../components/ui";
import { Seo } from "../lib/head";

const GROUPS: Array<{ title: string; links: Array<[string, string]> }> = [
  {
    title: "Platform",
    links: [
      ["/", "Home"],
      ["/platform", "Platform overview"],
      ["/features", "Features"],
      ["/pricing", "Pricing"],
      ["/customers", "Customers"],
      ["/demo", "Request a demo"],
    ],
  },
  {
    title: "Solutions",
    links: [
      ["/solutions/snf", "Long-term care (SNF)"],
      ["/solutions/asc", "Ambulatory surgical (ASC)"],
      ["/solutions/dialysis", "Dialysis"],
    ],
  },
  {
    title: "Company",
    links: [
      ["/about", "About"],
      ["/careers", "Careers"],
      ["/press", "Press kit"],
      ["/contact", "Contact"],
    ],
  },
  {
    title: "Resources",
    links: [
      ["/resources", "Resource hub"],
      ["/blog", "Blog"],
      ["/docs", "Docs"],
    ],
  },
  {
    title: "Trust",
    links: [
      ["/trust", "Trust center"],
      ["/security", "Security"],
      ["/hipaa", "HIPAA"],
      ["/privacy", "Privacy"],
      ["/terms", "Terms of service"],
      ["/cookies", "Cookies"],
      ["/dpa", "Data Processing Agreement"],
      ["/baa", "Business Associate Agreement"],
      ["/sla", "Service Level Agreement"],
      ["/aup", "Acceptable Use Policy"],
      ["/subprocessors", "Subprocessors"],
      ["/accessibility", "Accessibility"],
      ["/gdpr", "GDPR rights"],
      ["/ccpa", "CCPA rights"],
      ["/status", "Status"],
      ["/responsible-disclosure", "Responsible disclosure"],
      ["/sms-terms", "SMS terms & opt-in"],
    ],
  },
];

export function Sitemap() {
  return (
    <>
      <Seo title="Sitemap — WeConsult Rx" description="All pages on weconsultrx.com in one place." path="/sitemap" />
    <Section>
      <Container>
        <Eyebrow>Sitemap</Eyebrow>
        <Heading level={1} className="mt-3">
          Every page
        </Heading>
        <Lede className="mt-6">
          For machine-readable XML, see <code>/sitemap.xml</code>.
        </Lede>
        <div className="mt-12 grid gap-10 md:grid-cols-2 lg:grid-cols-3">
          {GROUPS.map((g) => (
            <div key={g.title}>
              <p className="text-xs uppercase tracking-tagline font-semibold text-forest-700">
                {g.title}
              </p>
              <ul className="mt-3 space-y-2">
                {g.links.map(([to, label]) => (
                  <li key={to}>
                    <Link to={to} className="text-ink-700 hover:text-forest-700">
                      {label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </Container>
    </Section>
    </>
  );
}
